var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12628 0.214122C8.99403 0.0815706 8.81447 0.00707876 8.62723 0.00707876C8.43998 0.00707876 8.26043 0.0815706 8.12818 0.214122L4.66667 3.66856L1.20516 0.207043C1.0729 0.0744918 0.893351 0 0.706105 0C0.51886 0 0.339307 0.0744918 0.207053 0.207043C-0.0690178 0.483115 -0.0690178 0.929077 0.207053 1.20515L3.66856 4.66666L0.207053 8.12817C-0.0690178 8.40425 -0.0690178 8.85021 0.207053 9.12628C0.483125 9.40235 0.929086 9.40235 1.20516 9.12628L4.66667 5.66477L8.12818 9.12628C8.40425 9.40235 8.85021 9.40235 9.12628 9.12628C9.40235 8.85021 9.40235 8.40425 9.12628 8.12817L5.66477 4.66666L9.12628 1.20515C9.39527 0.936156 9.39527 0.483115 9.12628 0.214122Z",
    fill: "#A5A7E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7d16b36b.svg";
export { ForwardRef as ReactComponent };